import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import DoneIcon from '@material-ui/icons/Delete'
import React from 'react'
import {useTranslation} from 'react-i18next'

type RevokeAppKeyModalProps = {
  isOpen: boolean
  onRevokeAppKeyCallback: () => void
  onCancel: () => void
}

export const RevokeAppKeyConfirmation = (props: RevokeAppKeyModalProps) => {
  const {onRevokeAppKeyCallback: onRevokeAppKeyEvent, isOpen, onCancel, ...other} = props
  const {t} = useTranslation()

  return (
    <>
      <Dialog maxWidth="xs" open={isOpen} {...other} data-test-id="app-keys-dialog-revoke">
        <DialogTitle> {t('appOverview.appDetail.revokeAppKey.dialogTitle')}</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            {t('appOverview.appDetail.revokeAppKey.dialogContent')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            startIcon={<CloseIcon />}
            onClick={onCancel}
            data-test-id="app-keys-dialog-revoke-btn-cancel"
          >
            {t('appOverview.appDetail.revokeAppKey.cancelButtonLabel')}
          </Button>
          <Button
            variant="contained"
            startIcon={<DoneIcon />}
            type="submit"
            onClick={onRevokeAppKeyEvent}
            data-test-id="app-keys-dialog-revoke-btn-submit"
          >
            {t('appOverview.appDetail.revokeAppKey.revokeButtonLabel')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
